import { Injectable } from '@angular/core';
import { isDevMode } from '@angular/core';
import { Statuses } from './enums/statuses.enum';
import { CancellationReasons } from './enums/cancellation-reasons.enum';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AppConfig {
  constructor(private translate: TranslateService) { }

  private readonly localURL = 'http://localhost:3472';
  //private readonly localURL = "http://192.168.0.30:3472";

  private readonly devURL = 'https://hubserverdev.azurewebsites.net';
  //private readonly devURL = 'http://localhost:3472';
  private readonly devURLAuth = 'https://hubserverdev.azurewebsites.net';
  private readonly prodAuthURL = 'https://hubtigerservices.azurewebsites.net';

  //private readonly prodURL = "http://localhost:3472";
  private readonly prodURL = 'https://hubtigerservices.azurewebsites.net';
  private readonly prodZAURL = 'https://hubtigerservices-za.azurewebsites.net';

  private readonly localURLNew = 'http://localhost:7071/api';
  //private readonly devURLNew = 'http://localhost:7071/api'; 
  private readonly devURLNew = 'https://hubtiger-api-dev.azurewebsites.net/api';
  private readonly prodURLNew = 'https://hubtiger-api.azurewebsites.net/api';
  //private readonly prodURLNew = 'http://localhost:7071/api';

  private readonly devURLPortal = 'http://hubtigerportaldev.azurewebsites.net/';
  private readonly prodURLPortal = 'http://hubtigerportal.azurewebsites.net/';

  private readonly rentalWidgetURLDev = 'https://hubtigerrentalsdev.z6.web.core.windows.net';
  private readonly rentalWidgetURLProd = 'https://rentals.hubtiger.com';

  private readonly workshopWidgetURLDev =
    'https://jjtestsite.z6.web.core.windows.net';
  private readonly workshopWidgetURLProd = 'https://bookings.hubtiger.com';

  private readonly DEV_API_KEY =
    'ME8v5qW0zWMP0oGtMFVDHKWuarvasV1mFQCW2uW3MyOmZUKQhTZPyQ==';
  private readonly PRO_API_KEY =
    'GthWdlDPlDOHgOm8xnueh2SbTVFoesHkCk2EprTXcowNFm66zfr2NQ==';
  private readonly OLD_PROD_API_KEY =
    'tlSc3bHMd5KrUNcSoUUaeSd7v43gVrD7kR_1h2A6xGd4AzFuZhcwdQ==';
  private readonly OLD_PROD_DEV_API_KEY =
    'tlSc3bHMd5KrUNcSoUUaeSd7v43gVrD7kR_1h2A6xGd4AzFuZhcwdQ=='; 
  private readonly grantType = 'password';


  //New POS API
  private readonly POS_DEV_KEY =
    'AC2cc2KIS3NuJInpPriWwi7Uk1bZyzFomcqKJAReClO1AzFugid0sw==';
  private readonly POS_PRO_KEY =
    'sSWlvyyETMVcd8ypbbx6Yx04vnIaTaLSPMC64twxY78bAzFu08kGhw==';

  //private readonly devPOSURL = "https://hubtiger-pos.azurewebsites.net/api";
  //private readonly devPOSURL = 'http://localhost:7030/api';
  private readonly devPOSURL = 'https://hubtiger-pos-dev.azurewebsites.net/api';
  private readonly prodPOSURL = 'https://hubtiger-pos.azurewebsites.net/api';
  //private readonly prodPOSURL = 'http://localhost:7030/api';
  //private readonly prodPOSURL = "http://localhost:7089/api";

  private readonly paygateIdDev = '10011072130';
  private readonly paygateIdProd = '1029805100016';

  private readonly stripKeyDev = 'pk_test_pT6K67ngrmRgD3ycPe0zpspA00gIBtEMTw';
  private readonly stripKeyProd = 'pk_live_gB2qnqJjEow8raxnS53Yjxmb00Caxfq56Z';
  private readonly VAPID_PUBLIC_KEY =
    'BHd6ZazEP6gfZI_OkuWZqoMoT1ILT0HqK7CtkZ2H8uPPGSUXXrycoWYX1ic1QV_ya3MAe6qvCrbsHm9ucdOayw0';

  private defaultLocale = 'en-gb';

  private DEV_PRODUCTFRUIT_KEY = 'CYWRC2efaMfIjHur';
  private PROD_PRODUCTFRUIT_KEY = 'IMBGwsYDVJEsPD0C';

  private DEV_PRODUCTFRUIT_CHECKLISTID = '5850';
  private PROD_PRODUCTFRUIT_CHECKLISTID = '6612';

  private readonly ENTRA_CLIENT_ID = 'ef6ab34b-cc5c-4cc6-b512-cd92cf5e7ebc';
  private readonly ENTRA_TENANT_ID = 'ece28882-215c-4218-8765-a8312e861463';
  private readonly ENTRA_AUTHORITY = `https://login.microsoftonline.com/${this.ENTRA_TENANT_ID}`;


  private languages = [
    { label: "Chinese (Simplified)", value: "zh-CHS", type: "bicycle", code: "zh-CN" },
    { label: "Chinese (Traditional)", value: "zh-CHT", type: "bicycle", code: "zh-HK" },
    { label: "Chinese (Taiwan)", value: "zh-TW", type: "bicycle", code: "zh-TW" },
    { label: 'Dutch', value: 'nl', type: 'bicycle', code: 'nl-NL' },
    { label: 'English (US)', value: 'en', type: 'bicycle', code: 'en-US' },
    { label: 'English (GB)', value: 'en-gb', type: 'bicycle', code: 'en-GB' },
    { label: 'Finnish', value: 'fi', type: 'bicycle', code: 'se-FI' },
    { label: 'French', value: 'fr', type: 'bicycle', code: 'fr-FR' },
    { label: 'German', value: 'de', type: 'bicycle', code: 'de-DE' },
    { label: 'Hungarian', value: 'hu', type: 'bicycle', code: 'hu-HU' },
    { label: 'Italian', value: 'it', type: 'bicycle', code: 'it-IT' },
    { label: "Japanese", value: "ja", type: "bicycle", code: "ja-JP" },
    { label: "Korean", value: "ko", type: "bicycle", code: "ko-KR" },
    { label: 'Norwegian', value: 'nb', type: 'bicycle', code: 'nb-NO' },
    { label: 'Portuguese', value: 'pt', type: 'bicycle', code: 'pt-PT' },
    { label: 'Polish', value: 'pl', type: 'bicycle', code: 'pl-PL' },
    { label: 'Slovenian', value: 'sl', type: 'bicycle', code: 'sl-SL' },
    { label: 'Spanish', value: 'es', type: 'bicycle', code: 'es-ES' },
    { label: 'Swedish', value: 'sv', type: 'bicycle', code: 'sv-SE' },
    { label: 'Turkish', value: 'tr', type: 'bicycle', code: 'tr-TR' },



    { label: 'Dutch', value: 'nl', type: 'jewellery', code: 'nl-NL' },
    { label: 'English (GB)', value: 'en-gb', type: 'jewellery', code: 'en-GB' },
    { label: 'English', value: 'en', type: 'jewellery', code: 'en-US' },

    { label: 'English (GB)', value: 'en-gb', type: 'clothing', code: 'en-GB' },
    { label: 'English', value: 'en', type: 'clothing', code: 'en-US' },

    { label: 'English (GB)', value: 'en-gb', type: 'boats', code: 'en-GB' },
    { label: 'English', value: 'en', type: 'boats', code: 'en-US' },

    { label: 'English', value: 'en', type: 'art-gallery', code: 'en-US' },

    {
      label: 'Dutch',
      value: 'nl',
      type: 'jewellery-and-accessories',
      code: 'nl-NL',
    },
    {
      label: 'English (US)',
      value: 'en',
      type: 'jewellery-and-accessories',
      code: 'en-US',
    },
    {
      label: 'English (GB)',
      value: 'en-gb',
      type: 'jewellery-and-accessories',
      code: 'en-GB',
    },
    {
      label: 'Finnish',
      value: 'fi',
      type: 'jewellery-and-accessories',
      code: 'se-FI',
    },
    {
      label: 'French',
      value: 'fr',
      type: 'jewellery-and-accessories',
      code: 'fr-FR',
    },
    {
      label: 'German',
      value: 'de',
      type: 'jewellery-and-accessories',
      code: 'de-DE',
    },
    {
      label: 'Italian',
      value: 'it',
      type: 'jewellery-and-accessories',
      code: 'it-IT',
    },
    {
      label: 'Norwegian',
      value: 'nb',
      type: 'jewellery-and-accessories',
      code: 'nb-NO',
    },
    {
      label: 'Portuguese',
      value: 'pt',
      type: 'jewellery-and-accessories',
      code: 'pt-PT',
    },
    {
      label: 'Polish',
      value: 'pl',
      type: 'jewellery-and-accessories',
      code: 'pl-PL',
    },
    {
      label: 'Slovenian',
      value: 'sl',
      type: 'jewellery-and-accessories',
      code: 'sl-SL',
    },
    {
      label: 'Spanish',
      value: 'es',
      type: 'jewellery-and-accessories',
      code: 'es-ES',
    },
    {
      label: 'Swedish',
      value: 'sv',
      type: 'jewellery-and-accessories',
      code: 'sv-SE',
    },

    { label: 'Dutch', value: 'nl', type: 'computer-repairs', code: 'nl-NL' },
    {
      label: 'English (US)',
      value: 'en',
      type: 'computer-repairs',
      code: 'en-US',
    },
    {
      label: 'English (GB)',
      value: 'en-gb',
      type: 'computer-repairs',
      code: 'en-GB',
    },
    { label: 'Finnish', value: 'fi', type: 'computer-repairs', code: 'se-FI' },
    { label: 'French', value: 'fr', type: 'computer-repairs', code: 'fr-FR' },
    { label: 'German', value: 'de', type: 'computer-repairs', code: 'de-DE' },
    { label: 'Italian', value: 'it', type: 'computer-repairs', code: 'it-IT' },
    {
      label: 'Norwegian',
      value: 'nb',
      type: 'computer-repairs',
      code: 'nb-NO',
    },
    {
      label: 'Portuguese',
      value: 'pt',
      type: 'computer-repairs',
      code: 'pt-PT',
    },
    { label: 'Polish', value: 'pl', type: 'computer-repairs', code: 'pl-PL' },
    {
      label: 'Slovenian',
      value: 'sl',
      type: 'computer-repairs',
      code: 'sl-SL',
    },
    { label: 'Spanish', value: 'es', type: 'computer-repairs', code: 'es-ES' },
    { label: 'Swedish', value: 'sv', type: 'computer-repairs', code: 'sv-SE' },

    { label: 'Dutch', value: 'nl', type: 'karts', code: 'nl-NL' },
    { label: 'English (US)', value: 'en', type: 'karts', code: 'en-US' },
    { label: 'English (GB)', value: 'en-gb', type: 'karts', code: 'en-GB' },
    { label: 'Finnish', value: 'fi', type: 'karts', code: 'se-FI' },
    { label: 'French', value: 'fr', type: 'karts', code: 'fr-FR' },
    { label: 'German', value: 'de', type: 'karts', code: 'de-DE' },
    { label: 'Italian', value: 'it', type: 'karts', code: 'it-IT' },
    { label: 'Norwegian', value: 'nb', type: 'karts', code: 'nb-NO' },
    { label: 'Portuguese', value: 'pt', type: 'karts', code: 'pt-PT' },
    { label: 'Polish', value: 'pl', type: 'karts', code: 'pl-PL' },
    { label: 'Slovenian', value: 'sl', type: 'karts', code: 'sl-SL' },
    { label: 'Spanish', value: 'es', type: 'karts', code: 'es-ES' },
    { label: 'Swedish', value: 'sv', type: 'karts', code: 'sv-SE' },

    { label: 'Dutch', value: 'nl', type: 'suspension', code: 'nl-NL' },
    { label: 'English (US)', value: 'en', type: 'suspension', code: 'en-US' },
    {
      label: 'English (GB)',
      value: 'en-gb',
      type: 'suspension',
      code: 'en-GB',
    },
    { label: 'Finnish', value: 'fi', type: 'suspension', code: 'se-FI' },
    { label: 'French', value: 'fr', type: 'suspension', code: 'fr-FR' },
    { label: 'German', value: 'de', type: 'suspension', code: 'de-DE' },
    { label: 'Italian', value: 'it', type: 'suspension', code: 'it-IT' },
    { label: 'Norwegian', value: 'nb', type: 'suspension', code: 'nb-NO' },
    { label: 'Portuguese', value: 'pt', type: 'suspension', code: 'pt-PT' },
    { label: 'Polish', value: 'pl', type: 'suspension', code: 'pl-PL' },
    { label: 'Slovenian', value: 'sl', type: 'suspension', code: 'sl-SL' },
    { label: 'Spanish', value: 'es', type: 'suspension', code: 'es-ES' },
    { label: 'Swedish', value: 'sv', type: 'suspension', code: 'sv-SE' },

    { label: 'English (US)', value: 'en', type: 'accessories', code: 'en-US' },
    { label: 'English (GB)', value: 'en-gb', type: 'accessories', code: 'en-GB' },

    { label: 'Dutch', value: 'nl', type: 'other', code: 'nl-NL' },
    { label: 'English (US)', value: 'en', type: 'other', code: 'en-US' },
    { label: 'English (GB)', value: 'en-gb', type: 'other', code: 'en-GB' },
    { label: 'Finnish', value: 'fi', type: 'other', code: 'se-FI' },
    { label: 'French', value: 'fr', type: 'other', code: 'fr-FR' },
    { label: 'German', value: 'de', type: 'other', code: 'de-DE' },
    { label: 'Italian', value: 'it', type: 'other', code: 'it-IT' },
    { label: 'Norwegian', value: 'nb', type: 'other', code: 'nb-NO' },
    { label: 'Portuguese', value: 'pt', type: 'other', code: 'pt-PT' },
    { label: 'Polish', value: 'pl', type: 'other', code: 'pl-PL' },
    { label: 'Slovenian', value: 'sl', type: 'other', code: 'sl-SL' },
    { label: 'Spanish', value: 'es', type: 'other', code: 'es-ES' },
    { label: 'Swedish', value: 'sv', type: 'other', code: 'sv-SE' },

  ];

  private units = [
    { label: 'Metric', value: 1 },
    { label: 'Imperial', value: 2 },
  ];

  public isDev() {
    //return false;
    return isDevMode();
  }
  
  public getStripKey() {
    return this.isDev() ? this.stripKeyDev : this.stripKeyProd;
  }

  public getOldProdKey() {
    return this.isDev() ? this.OLD_PROD_DEV_API_KEY : this.OLD_PROD_API_KEY;
  }

  public getVapidPublicKey() {
    return this.VAPID_PUBLIC_KEY;
  }

  public getPaygateId() {
    return this.isDev() ? this.paygateIdDev : this.paygateIdProd;
  }

  public getPaygateReturnUrl() {
    return (
      this.getEnvironmentNew().url +
      '/v4.0/Automation/Payments/Paygate/PaymentConfirmations?code=' +
      this.getEnvironmentNew().key
    );
  }

  getWorkshopWidgetURL() {
    if (this.isDev()) {
      return this.workshopWidgetURLDev;
    } else {
      return this.workshopWidgetURLProd;
    }
  }

  getRentalWidgetURL() {
    if (this.isDev()) {
      return this.rentalWidgetURLDev;
    } else {
      return this.rentalWidgetURLProd;
    }
  }

  public getShopRideURL() {
    if (this.isDev()) {
      return 'https://shoprideswidgetdev.z6.web.core.windows.net';
      //return '';
    } else {
      return 'https://shoprides.hubtiger.com';
    }
  }

  public getEnvironment() {
    if (this.isDev()) {
      return this.devURL;
      return this.localURL;
    } else {
      return this.prodURL;
    }
  }

  public getEnvironmentAuth() {
    if (this.isDev()) {
      return this.devURLAuth;
      return this.localURL;
    } else {
      return this.prodAuthURL;
    }
  }

  public getEnvironmentZA() {
    if (this.isDev()) {
      return this.devURL;
      return this.localURL;
    } else {
      return this.prodZAURL;
    }
  }

  public getEnvironmentNew() {
    if (this.isDev()) {
      return {
        url: this.devURLNew,
        key: this.DEV_API_KEY,
        portalUrl: this.devURLPortal,
      };
      return {
        url: this.localURLNew,
        key: this.DEV_API_KEY,
        portalUrl: this.devURLPortal,
      };
    } else {
      return {
        url: this.prodURLNew,
        key: this.PRO_API_KEY,
        portalUrl: this.prodURLPortal,
      };
    }
  }

  public getApiKey() {
    if (this.isDev()) {
      return this.DEV_API_KEY;
    } else {
      return this.PRO_API_KEY;
    }
  }

  public getProductFruitID() {
    if (this.isDev()) {
      return this.DEV_PRODUCTFRUIT_KEY;
    } else {
      return this.PROD_PRODUCTFRUIT_KEY;
    }
  }

  public getProductFruitChecklistID() {
    if (this.isDev()) {
      return this.DEV_PRODUCTFRUIT_CHECKLISTID;
    } else {
      return this.PROD_PRODUCTFRUIT_CHECKLISTID;
    }
  }

  public getGrantType() {
    return this.grantType;
  }

  public defaultUserPassword() {
    return 'Password123!'; //Personally I think this needs to move to the BE
  }

  private statusList: any = [];
  private serviceStatusList: any = [];
  private fullStatusListSummary: any = [];
  private jobActions: any = [];
  private cancelReasons: any = [];

  public getStatusList() {
    return this.statusList;
  }

  public getServiceStatusList() {
    return this.serviceStatusList;
  }

  public getFullStatusList() {
    return this.fullStatusListSummary;
  }

  public getStatusLabel(StatusID) {
    if (this.statusList.length === 0) {
      this.populateData();
    }
    var status = this.statusList
      .filter((x) => {
        return x.key === StatusID;
      })
      .pop();
    return status ? status.label : '';
  }

  public getJobActions() {
    return this.jobActions;
  }

  public getCancellationReasons() {
    return this.cancelReasons;
  }

  getLocale() {
    var locale = this.defaultLocale;
    if (locale === 'zh-CHT') {
      locale = 'zh-CN'; // Convert to traditional Chinese code
    } else if (locale === 'zh-CHS') {
      locale = 'zh-HK'; // Convert to simplified Chinese code
    }
    return locale;

  }

  setLocale(locale) {
    this.defaultLocale = locale;
  }

  getLanguages() {
    return this.languages;
  }

  getUnits() {
    return this.units;
  }

  getSupportedPOSSystems() {
    return [
      //{POSID : 4, Name: 'Sage Online', Image: require('../assets/pos/sage.png')},
      { POSID: 3, Name: 'Lightspeed-X', Image: '../assets/pos/vend.png' },
      {
        POSID: 6,
        Name: 'Lightspeed R',
        Image: '../assets/pos/lightspeed-r.png',
      },
      { POSID: 8, Name: 'Xero', Image: '../assets/pos/xero.png' },
      {
        POSID: 9,
        Name: 'Shopify',
        Image: '../assets/pos/shopify-hor.png',
      },
      {
        POSID: 10,
        Name: 'Cin7',
        Image: '../assets/pos/cin7Core.png',
      },
      {
        POSID: 11,
        Name: 'Northmill',
        Image: '../assets/pos/MoreFlo.png',
      },
      {
        POSID: 12,
        Name: 'Retail Express',
        Image: '../assets/pos/RetailExpress.png',
      },
      {
        POSID: 13,
        Name: 'Citrus Lime',
        Image: '../assets/pos/Citrus-lime-logo.jpg',
      },
      {
        POSID: 14,
        Name: 'EPOSNow',
        Image: '../assets/pos/eposNow.svg',
      },
      //{ POSID: 15, Name: "Wilmar", Image: require("../assets/pos/wilmar.svg") },
      {
        POSID: 16,
        Name: 'Netsuite',
        Image: '../assets/pos/netsuite.svg',
      },
      {
        POSID: 17,
        Name: 'Square',
        Image: '../assets/pos/Square-logo.jpg',
      },
      {
        POSID: 19,
        Name: 'Heartlands',
        Image: '../assets/pos/heartlandretail-logo.png',
      },
      {
        POSID: 20,
        Name: 'Teamwork',
        Image: '../assets/pos/Teamwork.png',
      },
      //{
      //  POSID: 21,
      //  Name: 'Erply',
      //  Image: '../assets/pos/erply-logo.png',
      //},svg
      //{
      //  POSID: 22,
      //  Name: 'Ascend',
      //  Image: '../assets/pos/Ascend.svg',
      //},
    ];
  }

  getSupportedRentalPOSSystems() {
    return [
      { POSID: 3, Name: 'Vend', Image: '../assets/pos/vend.png' },
      { POSID: 6, Name: 'LightSpeed', Image: '../assets/pos/lightspeed.png' },
      { POSID: 9, Name: 'Shopify', Image: '../assets/pos/shopify-hor.png' },
      {
        POSID: 12,
        Name: 'Retail Express',
        Image: '../assets/pos/RetailExpress.png',
      },
      {
        POSID: 13,
        Name: 'Citrus Lime',
        Image: '../assets/pos/Citrus-lime-logo.jpg',
      },
      { POSID: 17, Name: 'Square', Image: '../assets/pos/Square-logo.jpg' },
      {
        POSID: 19,
        Name: 'Heartlands',
        Image: '../assets/pos/heartlandretail-logo.png',
      }      
    ];
  }

  getTutorialVideos() {
    return [
      {
        type: 1,
        youtube_id: 'lujTBX3U-JA',
        title: this.translate.instant('tutorial.user_admin'),
      },
      {
        type: 2,
        youtube_id: 'gYLgD3LjezA',
        title: this.translate.instant('tutorial.service_types'),
      },
      {
        type: 3,
        youtube_id: '1guLTX0721Y',
        title: this.translate.instant('tutorial.message_templates'),
      },
      {
        type: 4,
        youtube_id: 'RNnh4o6U894',
        title: this.translate.instant('tutorial.pos_configuration'),
      },
      {
        type: 5,
        youtube_id: 'BK7WITaYAZ4',
        title: this.translate.instant('tutorial.customers'),
      },
    ];
  }

  populateData() {
    console.log(this.getPartnerData());
    this.statusList = [
      {
        key: Statuses.TOPICKUP,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 5).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 5).Label
            : this.translate.instant('bikeshop.statuses.to_pick_up'),
        icon: 'fa fa-fw fa-truck',
        apiPropertyName: 'Services_Collections',
        id: 5,
        index: 0,
        styleClass: 'ToPickUp',
        action: {
          label: this.translate.instant('bikeshop.status_actions.book_in'),
        },
        order: 1,
      },
      {
        key: Statuses.BOOKEDIN,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 15).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 15).Label
            : this.translate.instant('bikeshop.statuses.booked_in'),
        icon: 'fa fa-fw fa-calendar-check-o',
        apiPropertyName: 'Services_BookedIn',
        id: 10,
        index: 1,
        styleClass: 'BookedIn',
        action: {
          label: this.translate.instant('bikeshop.status_actions.assign'),
        },
        order: 2,
      },
      {
        key: Statuses.ASSIGNED,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 20).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 20).Label
            : this.translate.instant('bikeshop.statuses.assigned'),
        icon: 'fa fa-fw fa-user',
        apiPropertyName: 'Services_AssignedToTechnician',
        id: 20,
        index: 2,
        styleClass: 'AssignedtoTechnician',
        action: {
          label: this.translate.instant('bikeshop.status_actions.begin_job'),
        },
        order: 3,
      },
      {
        key: Statuses.WORKINGON,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 25).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 25).Label
            : this.translate.instant('bikeshop.statuses.working_on'),
        icon: 'fa fa-fw fa-wrench',
        apiPropertyName: 'Services_WorkingOnIt',
        id: 25,
        index: 3,
        styleClass: 'StartedWorking',
        action: {
          label: this.translate.instant('bikeshop.status_actions.complete'),
        },
        order: 8,
      },
      {
        key: Statuses.WARRANTY,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 26).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 26).Label
            : this.translate.instant('bikeshop.statuses.warranty'),
        icon: 'fa fa-fw fa-user',
        apiPropertyName: 'Services_WorkingOnWarranty',
        id: 26,
        index: 3,
        styleClass: 'StartedWarrantyJob',
        action: {
          label: this.translate.instant('bikeshop.status_actions.complete'),
        },
        order: 6,
      },
      {
        key: Statuses.INEEDHELP,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 31).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 31).Label
            : this.translate.instant('bikeshop.statuses.i_need_help'),
        icon: 'fa fa-fw fa-hourglass-2',
        apiPropertyName: 'Services_INeedHelp',
        id: 31,
        index: 4,
        styleClass: 'INeedHelp',
        action: null,
        order: 15,
      },
      {
        key: Statuses.WAITINGPARTS,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 35).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 35).Label
            : this.translate.instant('bikeshop.statuses.waiting_parts'),
        icon: 'fa fa-fw fa-hourglass-2',
        apiPropertyName: 'Services_WaitingForParts',
        id: 35,
        index: 4,
        styleClass: 'WaitingForParts',
        action: null,
        order: 5,
      },
      {
        key: Statuses.WAITINGCLIENT,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 30).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 30).Label
            : this.translate.instant('bikeshop.statuses.waiting_client'),
        icon: 'fa fa-fw fa-hourglass-2',
        apiPropertyName: 'Services_WaitingForClient',
        id: 30,
        index: 5,
        styleClass: 'WaitingForClient',
        action: null,
        order: 4,
      },
      {
        key: Statuses.COMPLETED,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 45).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 45).Label
            : this.translate.instant('bikeshop.statuses.bike_ready'),
        icon: 'fa fa-fw fa-thumbs-up',
        apiPropertyName: 'Services_ReadyForCollection',
        id: 45,
        index: 6,
        styleClass: 'ReadyforCollection',
        action: {
          label: this.translate.instant(
            'bikeshop.status_actions.bike_collected',
          ),
        },
        order: 9,
      },
      {
        key: Statuses.READY,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 45).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 45).Label
            : this.translate.instant('bikeshop.statuses.bike_ready'),
        icon: 'fa fa-fw fa-thumbs-up',
        apiPropertyName: 'Services_ReadyForCollection',
        id: 45,
        index: 6,
        styleClass: 'ReadyforCollection',
        action: {
          label: this.translate.instant(
            'bikeshop.status_actions.bike_collected',
          ),
        },
        order: 9,
      },
      {
        key: Statuses.COLLECTED,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 50).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 50).Label
            : this.translate.instant('bikeshop.statuses.collected'),
        icon: 'fa fa-fw fa-truck',
        apiPropertyName: 'Services_Collected',
        id: 50,
        index: 7,
        styleClass: 'Collected',
        action: null,
        order: 10,
      },
      {
        key: Statuses.TODROPPEDOFF,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 55).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 55).Label
            : this.translate.instant('bikeshop.statuses.to_deliver'),
        icon: 'fa fa-fw fa-truck',
        apiPropertyName: 'Services_Deliveries',
        id: 55,
        index: 8,
        styleClass: 'ToBeDelivered',
        action: null,
        order: 10,
      },

      {
        key: Statuses.FITTINGBOOKEDIN,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 16).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 16).Label
            : this.translate.instant('bikeshop.statuses.fitting_booked_in'),
        icon: 'fa fa-circle-o-notch',
        apiPropertyName: 'FittingBookedIn',
        id: 16,
        index: 11,
        styleClass: 'FittingBookedIn',
        action: null,
        order: 11,
      },
      {
        key: Statuses.FITTINGCOMPLETED,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 41).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 41).Label
            : this.translate.instant('bikeshop.statuses.fitting_completed'),
        icon: 'fa fa-circle-o-notch',
        apiPropertyName: 'FittingCompleted',
        id: 41,
        index: 12,
        styleClass: 'FittingCompleted',
        action: null,
        order: 12,
      },
    ];

    this.serviceStatusList = [
      {
        key: Statuses.TOPICKUP,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 5).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 5).Label
            : this.translate.instant('bikeshop.statuses.to_pick_up'),
        apiPropertyName: 'Services_Collections',
        id: 5,
        index: 0,
      },
      {
        key: 'Open',
        label: this.translate.instant('bikeshop.statuses.open_jobs'),
        apiPropertyName: 'Services_OpenJobs',
        id: 'open',
        index: 1,
      },
      {
        key: Statuses.READY,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 45).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 45).Label
            : this.translate.instant('bikeshop.statuses.bike_ready'),
        apiPropertyName: 'Services_ReadyForCollection',
        id: 45,
        index: 2,
      },
      {
        key: Statuses.TODROPPEDOFF,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 55).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 55).Label
            : this.translate.instant('bikeshop.statuses.to_deliver'),
        apiPropertyName: 'Services_Deliveries',
        id: 55,
        index: 3,
      },
      {
        key: Statuses.CANCELED,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 100).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 100).Label
            : this.translate.instant('bikeshop.statuses.cancelled'),
        apiPropertyName: 'Services_Cancellations',
        id: 100,
        index: 4,
      },
      {
        key: Statuses.INEEDHELP,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 31).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 31).Label
            : this.translate.instant('bikeshop.statuses.i_need_help'),
        icon: 'fa fa-fw fa-hourglass-2',
        apiPropertyName: 'Services_INeedHelp',
        id: 31,
        index: 4,
        styleClass: 'INeedHelp',
        action: null,
        order: 15,
      },
    ];

    this.jobActions = [
      {
        key: Statuses.BOOKEDIN,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 15).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 15).Label
            : this.translate.instant('bikeshop.job_actions.bike_received'),
        id: 20,
      },
      {
        key: Statuses.WAITINGFORWORK,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 20).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 20).Label
            : this.translate.instant('bikeshop.job_actions.pause'),
        id: 20,
      },
      {
        key: Statuses.WORKINGON,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 25).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 25).Label
            : this.translate.instant('bikeshop.job_actions.begin_job'),
        id: 25,
      },
      {
        key: Statuses.WARRANTY,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 26).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 26).Label
            : this.translate.instant('bikeshop.job_actions.warranty_job'),
        id: 26,
      },
      {
        key: Statuses.WAITINGPARTS,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 35).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 35).Label
            : this.translate.instant('bikeshop.job_actions.waiting_for_parts'),
        id: 35,
      },
      {
        key: Statuses.WAITINGCLIENT,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 30).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 30).Label
            : this.translate.instant('bikeshop.job_actions.waiting_for_client'),
        id: 30,
      },
      {
        key: Statuses.COMPLETED,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 40).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 40).Label
            : this.translate.instant('bikeshop.job_actions.job_completed'),
        id: 40,
      },
      {
        key: Statuses.CANCELED,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 100).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 100).Label
            : this.translate.instant('bikeshop.job_actions.cancel_job'),
        id: 100,
      },
      {
        key: Statuses.INEEDHELP,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 31).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 31).Label
            : this.translate.instant('bikeshop.job_actions.i_need_help'),
        id: 31,
      },
    ];

    this.cancelReasons = [
      {
        value: CancellationReasons.REASON_1,
        label: this.translate.instant('bikeshop.cancellation_reason.reason_1'),
      },
      {
        value: CancellationReasons.REASON_2,
        label: this.translate.instant('bikeshop.cancellation_reason.reason_2'),
      },
      {
        value: CancellationReasons.REASON_3,
        label: this.translate.instant('bikeshop.cancellation_reason.reason_3'),
      },
      {
        value: CancellationReasons.REASON_4,
        label: this.translate.instant('bikeshop.cancellation_reason.reason_4'),
      },
      {
        value: CancellationReasons.REASON_5,
        label: this.translate.instant('bikeshop.cancellation_reason.reason_5'),
      },
      {
        value: CancellationReasons.REASON_6,
        label: this.translate.instant('bikeshop.cancellation_reason.reason_6'),
      },
      {
        value: CancellationReasons.REASON_7,
        label: this.translate.instant('bikeshop.cancellation_reason.reason_7'),
      },
      {
        value: CancellationReasons.REASON_8,
        label: this.translate.instant('bikeshop.cancellation_reason.reason_8'),
      },
      {
        value: CancellationReasons.REASON_9,
        label: this.translate.instant('bikeshop.cancellation_reason.reason_9'),
      },
      {
        value: CancellationReasons.REASON_10,
        label: this.translate.instant('bikeshop.cancellation_reason.reason_10'),
      },
      {
        value: CancellationReasons.TESTING,
        label: this.translate.instant('bikeshop.cancellation_reason.testing'),
      },
      {
        value: CancellationReasons.OTHER,
        label: this.translate.instant('bikeshop.cancellation_reason.other'),
      },
    ];

    this.fullStatusListSummary = [
      {
        key: Statuses.SCHEDULED,
        label: this.translate.instant('bikeshop.statuses.scheduled'),
      },
      {
        key: Statuses.BOOKEDIN,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 15).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 15).Label
            : this.translate.instant('bikeshop.statuses.booked_in'),
      },
      {
        key: Statuses.ASSIGNED,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 20).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 20).Label
            : this.translate.instant('bikeshop.statuses.assigned'),
      },
      {
        key: Statuses.WORKINGON,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 25).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 25).Label
            : this.translate.instant('bikeshop.statuses.working_on'),
      },
      {
        key: Statuses.WARRANTY,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 26).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 26).Label
            : this.translate.instant('bikeshop.statuses.warranty'),
      },
      {
        key: Statuses.WAITINGPARTS,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 35).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 35).Label
            : this.translate.instant('bikeshop.statuses.waiting_parts'),
      },
      {
        key: Statuses.WAITINGCLIENT,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 30).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 30).Label
            : this.translate.instant('bikeshop.statuses.waiting_client'),
      },
      {
        key: Statuses.READY,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 45).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 45).Label
            : this.translate.instant('bikeshop.statuses.bike_ready'),
      },
      {
        key: Statuses.COMPLETED,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 45).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 45).Label
            : this.translate.instant('bikeshop.statuses.completed'),
      },
      {
        key: Statuses.COLLECTED,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 50).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 50).Label
            : this.translate.instant('bikeshop.statuses.bike_collected'),
      },
      {
        key: Statuses.CANCELED,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 100).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 100).Label
            : this.translate.instant('bikeshop.statuses.cancelled'),
      },
      {
        key: Statuses.INEEDHELP,
        label:
          this.getPartnerData() && this.getPartnerData().Statuses && this.getPartnerData().Statuses.find(x => x.StatusID == 31).Label
            ? this.getPartnerData().Statuses.find(x => x.StatusID == 31).Label
            : this.translate.instant('bikeshop.statuses.i_need_help'),
      },
    ];

    this.populateCustomStatuses(this.statusList);
    this.populateCustomStatuses(this.serviceStatusList);
    this.populateCustomStatuses(this.jobActions);
    this.populateCustomStatuses(this.fullStatusListSummary);

    console.log(this.statusList, this.serviceStatusList, this.jobActions, this.cancelReasons, this.fullStatusListSummary);
  }

  populateCustomStatuses(list: any = []) {
  
    if(!this.getPartnerData()){
      return;
    }
    console.log(this.getPartnerData());

    if (!this.getPartnerData().ShowINeedHelp)
      return;

    var statuses = [21, 22, 23, 24, 27, 28, 29, 32, 33];
    var partnerStatuses = this.getPartnerData().Statuses;
    console.log(partnerStatuses);
    statuses.forEach(x => {
      var classStyle = "";
      switch (x) {
        case 21: classStyle = "CustomColourOne"; break;
        case 22: classStyle = "CustomColourTwo"; break;
        case 23: classStyle = "CustomColourThree"; break;
        case 24: classStyle = "CustomColourFour"; break;
        case 27: classStyle = "CustomColourFive"; break;
        case 28: classStyle = "CustomColourSix"; break;
        case 29: classStyle = "CustomColourSeven"; break;
        case 32: classStyle = "CustomColourEight"; break;
        case 33: classStyle = "CustomColourNine"; break;
      }

      var apiName = "";
      switch (x) {
        case 21: apiName = "Services_CustomStatusOne"; break;
        case 22: apiName = "Services_CustomStatusTwo"; break;
        case 23: apiName = "Services_CustomStatusThree"; break;
        case 24: apiName = "Services_CustomStatusFour"; break;
        case 27: apiName = "Services_CustomStatusFive"; break;
        case 28: apiName = "Services_CustomStatusSix"; break;
        case 29: apiName = "Services_CustomStatusSeven"; break;
        case 32: apiName = "Services_CustomStatusEight"; break;
        case 33: apiName = "Services_CustomStatusNine"; break;
      }

      if (partnerStatuses) {
        var status = partnerStatuses.find(s => s.StatusID == x).Label;
        if (status)
          if (status.length > 0) {
            list.push({
              key: x,
              label: status,
              apiPropertyName: apiName,
              id: x,
              index: 100,
              styleClass: classStyle
            });
          }
      }
    });

    return list;
  }

  populateDataCyclistPlatform(partnerData) {
    this.statusList = [
      {
        key: Statuses.TOPICKUP,
        label: partnerData.pickupLabel
          ? partnerData.pickupLabel
          : this.translate.instant('bikeshop.statuses.to_pick_up'),
        icon: 'fa fa-fw fa-truck',
        apiPropertyName: 'Services_Collections',
        id: 5,
        index: 0,
        styleClass: 'ToPickUp',
        action: {
          label: this.translate.instant('bikeshop.status_actions.book_in'),
        },
        order: 1,
      },
      {
        key: Statuses.BOOKEDIN,
        label: partnerData.bookedInLabel
          ? partnerData.bookedInLabel
          : this.translate.instant('bikeshop.statuses.booked_in'),
        icon: 'fa fa-fw fa-calendar-check-o',
        apiPropertyName: 'Services_BookedIn',
        id: 10,
        index: 1,
        styleClass: 'BookedIn',
        action: {
          label: this.translate.instant('bikeshop.status_actions.assign'),
        },
        order: 2,
      },
      {
        key: Statuses.ASSIGNED,
        label: partnerData.waitingForWorkLabel
          ? partnerData.waitingForWorkLabel
          : this.translate.instant('bikeshop.statuses.assigned'),
        icon: 'fa fa-fw fa-user',
        apiPropertyName: 'Services_AssignedToTechnician',
        id: 20,
        index: 2,
        styleClass: 'AssignedtoTechnician',
        action: {
          label: this.translate.instant('bikeshop.status_actions.begin_job'),
        },
        order: 3,
      },
      {
        key: Statuses.WORKINGON,
        label: partnerData.workingOnLabel
          ? partnerData.workingOnLabel
          : this.translate.instant('bikeshop.statuses.working_on'),
        icon: 'fa fa-fw fa-wrench',
        apiPropertyName: 'Services_WorkingOnIt',
        id: 25,
        index: 3,
        styleClass: 'StartedWorking',
        action: {
          label: this.translate.instant('bikeshop.status_actions.complete'),
        },
        order: 8,
      },
      {
        key: Statuses.WARRANTY,
        label: partnerData.warrantyLabel
          ? partnerData.warrantyLabel
          : this.translate.instant('bikeshop.statuses.warranty'),
        icon: 'fa fa-fw fa-user',
        apiPropertyName: 'Services_WorkingOnWarranty',
        id: 26,
        index: 3,
        styleClass: 'StartedWarrantyJob',
        action: {
          label: this.translate.instant('bikeshop.status_actions.complete'),
        },
        order: 6,
      },
      {
        key: Statuses.INEEDHELP,
        label: partnerData.iNeedHelpLabel
          ? partnerData.iNeedHelpLabel
          : this.translate.instant('bikeshop.statuses.i_need_help'),
        icon: 'fa fa-fw fa-hourglass-2',
        apiPropertyName: 'Services_INeedHelp',
        id: 31,
        index: 4,
        styleClass: 'INeedHelp',
        action: null,
        order: 7,
      },
      {
        key: Statuses.WAITINGPARTS,
        label: partnerData.waitingForPartsLabel
          ? partnerData.waitingForPartsLabel
          : this.translate.instant('bikeshop.statuses.waiting_parts'),
        icon: 'fa fa-fw fa-hourglass-2',
        apiPropertyName: 'Services_WaitingForParts',
        id: 35,
        index: 4,
        styleClass: 'WaitingForParts',
        action: null,
        order: 5,
      },
      {
        key: Statuses.WAITINGCLIENT,
        label: partnerData.waitingForClientLabel
          ? partnerData.waitingForClientLabel
          : this.translate.instant('bikeshop.statuses.waiting_client'),
        icon: 'fa fa-fw fa-hourglass-2',
        apiPropertyName: 'Services_WaitingForClient',
        id: 30,
        index: 5,
        styleClass: 'WaitingForClient',
        action: null,
        order: 4,
      },
      {
        key: Statuses.READY,
        label: partnerData.completedLabel
          ? partnerData.completedLabel
          : this.translate.instant('bikeshop.statuses.bike_ready'),
        icon: 'fa fa-fw fa-thumbs-up',
        apiPropertyName: 'Services_ReadyForCollection',
        id: 45,
        index: 6,
        styleClass: 'ReadyforCollection',
        action: {
          label: this.translate.instant(
            'bikeshop.status_actions.bike_collected',
          ),
        },
        order: 9,
      },
      {
        key: Statuses.COLLECTED,
        label: partnerData.collectedLabel
          ? partnerData.collectedLabel
          : this.translate.instant('bikeshop.statuses.collected'),
        icon: 'fa fa-fw fa-truck',
        apiPropertyName: 'Services_Collected',
        id: 50,
        index: 7,
        styleClass: 'Collected',
        action: null,
        order: 10,
      },
      {
        key: Statuses.TODROPPEDOFF,
        label: partnerData.deliveryLabel
          ? partnerData.deliveryLabel
          : this.translate.instant('bikeshop.statuses.to_deliver'),
        icon: 'fa fa-fw fa-truck',
        apiPropertyName: 'Services_Deliveries',
        id: 55,
        index: 8,
        styleClass: 'ToBeDelivered',
        action: null,
        order: 10,
      },
    ];
  }

  getPartnerCustomStatus(statusId) {
    //if (this.statusList.length <= 0) {
    this.populateData();
    //}

    var status = this.statusList.filter((x) => x.key == statusId).pop();
    //console.log(statusId);
    //console.log(this.statusList);
    //console.log(status);
    if (status == null) {
      return 'Invalid Status';
    }
    return status.label;
  }

  //This is to map the message template labels to any customized status - this relationship should have existed in the DB :( - MK
  getCustomLabelForMessageTag(messageTag, label, returnEmpty) {
    if (messageTag === 'service.pickup')
      return returnEmpty &&
        this.getPartnerData() &&
        this.getPartnerData().PickupLabel
        ? ''
        : this.getPartnerData() && this.getPartnerData().PickupLabel
          ? this.getPartnerData().PickupLabel
          : label;
    if (messageTag === 'service.bookin')
      return returnEmpty &&
        this.getPartnerData() &&
        this.getPartnerData().BookedInLabel
        ? ''
        : this.getPartnerData() && this.getPartnerData().BookedInLabel
          ? this.getPartnerData().BookedInLabel
          : label;
    if (messageTag === 'service.assign')
      return returnEmpty &&
        this.getPartnerData() &&
        this.getPartnerData().WaitingForWorkLabel
        ? ''
        : this.getPartnerData() && this.getPartnerData().WaitingForWorkLabel
          ? this.getPartnerData().WaitingForWorkLabel
          : label;
    if (messageTag === 'service.start')
      return returnEmpty &&
        this.getPartnerData() &&
        this.getPartnerData().WorkingOnLabel
        ? ''
        : this.getPartnerData() && this.getPartnerData().WorkingOnLabel
          ? this.getPartnerData().WorkingOnLabel
          : label;
    if (messageTag === 'service.warranty')
      return returnEmpty &&
        this.getPartnerData() &&
        this.getPartnerData().WarrantyLabel
        ? ''
        : this.getPartnerData() && this.getPartnerData().WarrantyLabel
          ? this.getPartnerData().WarrantyLabel
          : label;
    if (messageTag === 'service.waitingforparts')
      return returnEmpty &&
        this.getPartnerData() &&
        this.getPartnerData().WaitingForPartsLabel
        ? ''
        : this.getPartnerData() && this.getPartnerData().WaitingForPartsLabel
          ? this.getPartnerData().WaitingForPartsLabel
          : label;
    if (messageTag === 'service.waitingforclient')
      return returnEmpty &&
        this.getPartnerData() &&
        this.getPartnerData().WaitingForClientLabel
        ? ''
        : this.getPartnerData() && this.getPartnerData().WaitingForClientLabel
          ? this.getPartnerData().WaitingForClientLabel
          : label;
    if (messageTag === 'service.complete')
      return returnEmpty &&
        this.getPartnerData() &&
        this.getPartnerData().CompletedLabel
        ? ''
        : this.getPartnerData() && this.getPartnerData().CompletedLabel
          ? this.getPartnerData().CompletedLabel
          : label;
    if (messageTag === 'service.collected')
      return returnEmpty &&
        this.getPartnerData() &&
        this.getPartnerData().CollectedLabel
        ? ''
        : this.getPartnerData() && this.getPartnerData().CollectedLabel
          ? this.getPartnerData().CollectedLabel
          : label;
    if (messageTag === 'service.dropoff')
      return returnEmpty &&
        this.getPartnerData() &&
        this.getPartnerData().DeliveryLabel
        ? ''
        : this.getPartnerData() && this.getPartnerData().DeliveryLabel
          ? this.getPartnerData().DeliveryLabel
          : label;
    if (messageTag === 'service.deliverybooked')
      return returnEmpty &&
        this.getPartnerData() &&
        this.getPartnerData().DeliveryBookedLabel
        ? ''
        : this.getPartnerData() && this.getPartnerData().DeliveryBookedLabel
          ? this.getPartnerData().DeliveryBookedLabel
          : label;
    return label;
  }

  getWYSIWYGUploadURL() {
    return `${this.getEnvironmentNew().url}/WYSIWYG/Content/Upload?code=${this.getEnvironmentNew().key
      }`;
  }

  getMessageTemplateOrder() {
    return {
      'service.assign': 5,
      'service.start': 6,
      'service.waitingforclient': 8,
      'service.waitingforparts': 9,
      'service.complete': 11,
      'service.collected': 12,
      'service.warranty': 7,
      'bike.sale.followup': 2,
      'service.reminder': 15,
      'service.bookin': 3,
      'service.pickup': 1,
      'service.dropoff': 13,
      'service.bookingreminder': 4,
      'fitting.fittingreminder': 2,
      'service.approval': 8,
      'service.multiapproval': 8,
      'service.pickedup': 2,
      'service.waitingforpartsdelay': 10,
      'fitting.followup': 4,
      'fitting.bookin': 1,
      'fitting.completed': 3,
      'bike.sale': 1,
      'service.collectionreminder': 4,
      'service.deliverybooked': 14,
    };
  }

  public getPartnerData() {
    let partnerData: any;
    if (localStorage.getItem('PartnerData')) {
      partnerData = JSON.parse(
        decodeURIComponent(
          escape(window.atob(localStorage.getItem('PartnerData'))),
        ),
      ).data;
    }
    return partnerData;
  }

  public getSupplierInfo(id) {
    var suppliers = [
      { id: 1, name: 'QBP' },
      { id: 2, name: 'QBP' },
      { id: 3, name: 'HLC' },
      { id: 5, name: 'JBI' },
      { id: 6, name: 'HLC' },
    ];

    return suppliers
      .filter((x) => {
        return x.id === id;
      })
      .pop();
  }


  public getPOSEnvironment() {
    if (this.isDev()) {
      return {
        url: this.devPOSURL,
        key: this.POS_DEV_KEY,
        portalUrl: this.devURLPortal,
      };
    } else {
      return {
        url: this.prodPOSURL,
        key: this.POS_PRO_KEY,
        portalUrl: this.prodURLPortal,
      };
    }
  }

  //This returns the type of store e.g. bicycle shop, motorbike, jewellery etc. We use this to pick the correct language file for the store
  public getPartnerType(partnerType = null) {
    if (this.getPartnerData() || partnerType) {
      var partnerType = partnerType || this.getPartnerData().PartnerType;
      switch (partnerType) {
        case 1:
          return 'bicycle';
          break;
        case 2:
          return 'jewellery-and-accessories';
          break;
        case 3:
          return 'computer-repairs';
          break;
        case 4:
          return 'karts';
          break;
        case 5:
          return 'suspension';
          break;
        case 6:
          return 'other';
          break;
        case 7:
          return 'other';
          break;
        case 8:
          return 'boats';
          break;
        case 9:
          return 'other';
          break;
        case 10:
          return 'other';
          break;
        case 11:
          return 'jewellery';
          break;
        case 12:
          return 'clothing';
          break;
        case 13:
          return 'art-gallery';
          break;
        case 14:
          return 'accessories';
          break;
        case 99:
          return 'other';
          break;
        default:
          return 'bicycle';
          break;
      }
    } else {
      return 'bicycle';
    }
  }

  getPartnerTypes() {
    return [
      { value: 1, label: 'Bicycle Store' },
      { value: 2, label: 'Jewellery & Accessories Store' },
      { value: 3, label: 'PC / Mobile Repair Store' },
      { value: 4, label: 'Karts' },
      { value: 5, label: 'Suspension Servicing' },
      { value: 6, label: 'Scooter Store' },
      { value: 7, label: 'Motorcycle Store' },
      { value: 8, label: 'Boat / Watercraft Store' },
      { value: 9, label: 'Sports Equipment Store' },
      { value: 10, label: 'Scuba Diving Store' },
      { value: 11, label: 'Jewellery Store' },
      { value: 12, label: 'Clothing Store' },
      { value: 13, label: 'Art Gallery' },
      { value: 14, label: 'Accessories' },
      { value: 99, label: 'Other' },
    ];
  }

  public getEntraConfig() {
    return {
      clientId: this.ENTRA_CLIENT_ID,
      tenantId: this.ENTRA_TENANT_ID,
      authority: this.ENTRA_AUTHORITY,
      redirectUri: window.location.origin,
      scopes: ['openid', 'profile', 'email']
    };
  }

  private GIGYA_CLIENT_ID_DEV = 'Mh7RP3SjM-ZhwRBq6SSwzFW8';
  private GIGYA_API_KEY_DEV = '4_bSnuRvlsWsA41T0G-bnOVg';
  private GIGYA_CLIENT_ID_PROD = 'RRr1RhqnmaOCZ-Ol4JXalpMg';
  private GIGYA_API_KEY_PROD = '4_frI7VS6Jjr3Rvuw0HwUbKA'; 

  public getGigyaConfig() {
    return {
      clientId: this.isDev() ? this.GIGYA_CLIENT_ID_DEV : this.GIGYA_CLIENT_ID_PROD,
      baseUrl: 'https://fidm.us1.gigya.com/oidc/op/v1.0',
      apiKey: this.isDev() ? this.GIGYA_API_KEY_DEV : this.GIGYA_API_KEY_PROD,
    };
  }
}
